module.exports = __webpack_public_path__ + "img/logo-h.40594c19.png";